class localhostSettings { }

const win: any = window;
if (window.location.href.includes("localhost")) {
    !!!win["lang"] && (win["lang"] = "en");
    document.documentElement.lang = win["lang"];    
    !!!win["base_api_url"] && (win["base_api_url"] = "https://apidev.mobily.com.sa/api");
    !!!win["clientToken"] && (win["clientToken"] = "38995dfc-5fc7-466c-b7af-5f7449563ad5");
    !!!win['errorPageUrl'] && (win['errorPageUrl'] = `http://ssta004:8080/wps/portal/web/personal/store/error`);
}

export default localhostSettings;
